import React, { FC, memo } from 'react';
import style from './toast.module.scss';


interface Props {
  text: string;
  textStyle: any;
}


const Toast: FC<Props> = memo(({ text, textStyle }) => (

  <div className={style.toastCover}>
    <div className={style.toastContainer} style={textStyle || {}}>
      {text}
    </div>
  </div>
));

export default Toast;
